import { Button } from '@dtx-company/design-system/src'
import { PlanPurchaseFormSubmitButtonProps } from './PlanPurchaseFormSubmitButtonProps'
import { useInternalPlanPurchaseFormContext } from '../PlanPurchaseForm/context/useInternalPlanPurchaseFormContext'
import React from 'react'

export function PlanPurchaseFormSubmitButton(
  props: PlanPurchaseFormSubmitButtonProps
): JSX.Element {
  const { isSubmitted } = useInternalPlanPurchaseFormContext()

  return <Button {...props} type="submit" loading={isSubmitted} />
}
